import React, {useState, useEffect} from "react";
import axios from "axios";
import ReactDOM from "react-dom";
import { DataGrid , GridToolbar, GridToolbarContainer } from "@mui/x-data-grid";
//import Select, { StylesConfig }  from "react-select";
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import ReactPDF from '@react-pdf/renderer';
//import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useSearchParams } from 'react-router-dom';
import Header from "./HeaderEXT";

import {Input, Button, Box, Stack, AppBar, styled, Toolbar,Typography, InputBase,Avatar } from "@mui/material";
import { PDFViewer } from '@react-pdf/renderer';

import { usePDF } from 'react-to-pdf';
//import { float } from "html2canvas/dist/types/css/property-descriptors/float";

//import { Document, Page } from 'react-pdf';
//import { usePDF } from 'react-to-pdf';

//import { usePDF } from 'react-to-pdf';

const StyledBox= styled(Box)({
    marginTop: "10px",
    marginBottom: "10px",
    marginLeft: "5px",
});

export default function ParentReportTemplate( { reportDataEXT }){
    
    const { toPDF, targetRef } = usePDF({filename: 'page.pdf'});
    
    const [studentName, setStudentName]=useState('');
    const [streamName, setStreamName]=useState('');
    const [academicYear, setAcademicYear]=useState('');

    const [examName, setExamName]=useState('');
    
    const [studentNameStr, setStudentNameStr]=useState( 'Student Name ' + studentName);

    const [reportData, setReportData]=useState([]);
    const [APIROOTURL, setAPIROOTURL]=useState('https://bfatechnologies.tech/tz_schools_is/school/');
    
    const [ReportTitle, setReportTitle]=useState('');
    const [showGrid, setShowGrid]=useState(false);

    
  const CustomGridToolbar = () => {
    return (
      <>
      <GridToolbarContainer>
          
          <div sx={{width: '100%'}}>
             
          </div>

         <div className = "pcontainer">
            <div className = "pleft"><Header title='     '></Header></div>
            <div className = "pright"><Header title={'Student examination report for student   ' + studentName}></Header></div>   
        </div>
       
      

        <div className = "pcontainer">
        
        <div className = "pright"><Header title={'Exam ' + examName + ', Stream ' + streamName + ', Academic year ' +  academicYear}></Header></div>
             
        </div>
        
       

            
      </GridToolbarContainer>
      <GridToolbar />
      </>
    )
  }

    const [columns, setColumns]=useState([
        {
          field: "id", 
          headerName: 'ID' ,
          flex:0.5,
        },
  
        {
          field: "subject", 
          headerName: 'SUBJECT' ,
          flex:1.5,
        },
  
        {
          field: "score", 
          headerName: 'SCORE' ,
          flex:1,
        },
  
        {
          field: "grade", 
          headerName: 'GRADE' ,
          flex:1,
        },
  
        {
          field: "divisionPoints", 
          headerName: 'DIV POINTS' ,
          flex:1,
        },
  
        {
          field: "gpaPoints", 
          headerName: 'GPA POINTS' ,
          flex:1,
        },
  
        {
          field: "remarks", 
          headerName: 'REMARKS' ,
          flex:2,
        },
  
        {
          field: "position", 
          headerName: 'POSITION' ,
          flex:2,
        },
  
      ]);
     
    const styles = StyleSheet.create({
        page: {
          flexDirection: 'row',
          backgroundColor: '#E4E4E4'
        },
        section: {
          margin: 10,
          padding: 10,
          flexGrow: 1
        }
      });

    const [searchParams, setSearchParams]=useSearchParams();
    const stestr = searchParams.get('ste');
    //const query = new URLSearchParams(props.location.search);
    //const token = query.get('token')
    console.log("stestr=" + stestr)//123
    
    const MyDocument = () => (
        <Document sx={{width: '600px', height: '800px'}}>
          <Page size="A4" style={styles.page}>
            <View style={styles.section}>
                <table>
                    <thead>
                        <tr>SNO</tr>
                        <tr>SNO</tr>
                        <tr>SNO</tr>
                    </thead>
                
                </table>
              <Text>Section #1</Text>
              
                
               
                
            </View>
            <View style={styles.section}>
              <Text>Section #2</Text>
            </View>
          </Page>
        </Document>
      );
    //import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

    //ReactPDF.render(<MyDocument />, `${__dirname}/example.pdf`);
    //ReactDOM.render(<App />, document.getElementById('root'));
    //import { PDFViewer } from '@react-pdf/renderer';
    useEffect(()=>{
       //alert(schoolIdGlobal + "," + usersId)
       //alert(stestr)
       let APIURL= APIROOTURL + "ParentReportForSingleStudentFullExamResultsViewEXT/" + stestr
       console.log(APIURL);
   
   let headerOptions={
       method: 'GET',
   }
   
   fetch(APIURL, headerOptions)
   .then( response => response.json())
   .then( json =>{
    console.log("json 123 =" + json);
    //console.log("json 5123 =" + json[0]['name']);
    //console.log("json 123 =" + json[0].name);
    setStudentName(json.fullName);
    setStreamName(json.streamName);
    setAcademicYear(json.academicYear);
    setExamName(json.examName);

    let newList=[];
    
    {
     json.data.map(function(dt, index){
      
       newList.push(
         //yamal
         
         {
           id: dt.id, 
           subject: dt.subject,
           score: dt.score,
           grade: dt.grade,
           remarks: dt.remarks,
           divisionPoints: dt.divisionPoints,
           gpaPoints: dt.gpaPoints,
           position: dt.position
         }
       )
       console.log("grade=" + dt.grade)
     })
   }
   
   //alert(newList.length);
   
   setReportData(newList);
   if (newList.length == 0) {
     
    // setListStatus(false);
   } else {
     //setListStatus(true);
   }
   
    //loadExamSubClass(json)
   })
   .catch(error=> console.log("error=" + error))
    
   
     },[stestr])
    
     {/***<Header title="STUDENTS EXAM REPORTS" subtitle="Students exam reports" />***/}
        
    return(
      
        //sx={{ m: 1, backgroundColor: '#2e7c67', }}
        <div style={{ backgroundColor: '#2e7c67'}}>
        
        <Stack direction="row" spacing={1} justifyContent="space-between">

          <StyledBox flex={1}>
        
           
          </StyledBox>

          <StyledBox flex={10}>
        
          <div sx={{height: '45px'}}>
          
          </div>
          
          <div sx={{height: '45px'}}>
            
          </div>

        <Button
        type="submit" color="secondary" variant="contained"
        sx={{ marginLeft: '12px', width: '190px', marginTop: '10px', alignContent: 'center'}}
        onClick={()=>{toPDF()}}>VIEW REPORT IN PDF</Button>
        
        <div sx={{height: '45px'}}></div>

        <div ref={targetRef} sx={{marginTop: '22px',}}>

        <div sx={{}}>
            
            {/***<Text sx={{}}>Student Name: {studentName}</Text>***/}
            {/*** *
            <Stack direction="row" spacing={1} justifyContent="space-between">
             <StyledBox flex={1.5}><Header title=''></Header></StyledBox>
             <StyledBox flex={2}><Header title=''></Header></StyledBox>
             <StyledBox flex={8.5}></StyledBox>
            </Stack>

            <Stack direction="row" spacing={1} justifyContent="space-between">
             <StyledBox flex={2.5}><Header title='Student Examination Report     '></Header></StyledBox>
             <StyledBox flex={4}><Header title=''></Header></StyledBox>
             <StyledBox flex={5.5}></StyledBox>
            </Stack>

            <Stack direction="row" spacing={1} justifyContent="space-between">
             <StyledBox flex={1.44}><Header title='Exam Name'></Header></StyledBox>
             <StyledBox flex={3}><Header title={examName}></Header></StyledBox>
             <StyledBox flex={7.56}></StyledBox>
            </Stack>
            
            <Stack direction="row" spacing={1} justifyContent="space-between">
             <StyledBox flex={1.5}><Header title='Student Name'></Header></StyledBox>
             <StyledBox flex={3}><Header title={studentName}></Header></StyledBox>
             <StyledBox flex={7.5}></StyledBox>
            </Stack>

            <Stack direction="row" spacing={1} justifyContent="space-between">
             <StyledBox flex={1.5}><Header title='Stream Name'></Header></StyledBox>
             <StyledBox flex={3}><Header title={streamName}></Header></StyledBox>
             <StyledBox flex={7.5}></StyledBox>
            </Stack>

            <Stack direction="row" spacing={1} justifyContent="space-between">
             <StyledBox flex={1.5}><Header title='Academic Year'></Header></StyledBox>
             <StyledBox flex={3}><Header title={academicYear}></Header></StyledBox>
             <StyledBox flex={7.5}></StyledBox>
            </Stack>
            ***/}
        </div>
              <DataGrid 
                checkboxSelection 
                rows={reportData} 
                columns={columns} 
                //style={{ backgroundColor: '##a4a9fc'}}
                sx={{ m: 1, backgroundColor: '#2e7c67', }}
                slots={{ toolbar: CustomGridToolbar }}

                isRowSelectable = {(params) => params.row.quantity > 50000}
                //checkboxSelection
                />
         </div>
        
        
        </StyledBox>
        <StyledBox flex={1}>
        
           
        </StyledBox>
        </Stack>

        {/*** *
        <PDFViewer>
         <MyDocument />
         </PDFViewer>
         ***/}
        </div>
    )
}
//react-pdf
 {/***
              <DataGrid 
                checkboxSelection 
                rows={reportData} 
                columns={columns} 
                
                slots={{ toolbar: CustomGridToolbar }}
                />
              ):''
              ***/}